import { Form, FormGroup, Input, Label, Button, Card, CardBody, CardHeader } from 'reactstrap';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SescLogo from './Assets/Sesc-SC-Logo.png';
import './Login.css'
import {
    QrCodeScan
} from 'react-bootstrap-icons';
import projetoAnjoIcone from './ProjetoAnjoAzul.png'


const Login = ({ token, logar, putUser, putSenha }) => {
    const navigate = useNavigate();

    const [authToken, setAuthToken] = useState(token);

    const [usuario, setUsuario] = useState('');
    const [senha, setSenha] = useState('');

    useEffect(() => {
        if (authToken) {
            navigate("/dashboard");
        } else {
            navigate("/");
        }
    },[])

    const checkForEnter = (e) => {
        let key = e.key;
        if (key === "Enter" || key === "NumpadEnter") {
            logar();
        }
    }

    const redirecionarGeradorQR = () => {
        navigate("/gerarCpfQrCode");
    }

   return (
       <div className="Home">
           <div className="Titulo">
               <strong>ANJO SESC</strong>
           </div>

           <div className="LoginForm">
               <Card className="CardLogin">
                   <CardHeader style={{
                       backgroundColor: 'white',
                       padding: '0px'
                   }}>
                       <img src={SescLogo} className="Logo" />

                   </CardHeader>

                   <CardBody style={{

                       backgroundColor: 'white'
                   }}>
                       <Form >
                           <FormGroup floating >
                               <Input
                                   id="login"
                                   name="login"
                                   placeholder="Login"
                                   type="login"
                                   value={usuario}
                                   onChange={(e) => {
                                       putUser(e.target.value)
                                       setUsuario(e.target.value)
                                   }}
                               />
                               <Label for="login">
                                   Login
                               </Label>
                           </FormGroup>
                           {' '}
                           <FormGroup floating>
                               <Input
                                   id="senha"
                                   name="senha"
                                   placeholder="Senha"
                                   type="password"
                                   value={senha}
                                   onKeyPress={checkForEnter}
                                   onChange={(e) => {
                                       putSenha(e.target.value)
                                       setSenha(e.target.value)
                                   }}
                               />
                               <Label for="senha">
                                   Senha
                               </Label>
                           </FormGroup>
                           {' '}
                           <Button id="SubmitButton" onClick={logar}>
                               Enviar
                           </Button>
                       </Form>
                   </CardBody>
               </Card>
           </div>
           <Button id="RedirQR" onClick={() => redirecionarGeradorQR()}>
           <QrCodeScan size={25} id="IconeRedirQR" />
               Gerador QR
           </Button>
       </div>
    );
}

export default Login;